import ViewAdminProfile from "@/components/ViewAdminProfile/viewAdminProfile.component";
import ViewProfile from "@/components/ViewProfile/viewProfile.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { AppContext } from "@/services/AppContext/appContext";
import React, { useContext } from "react";

type PageProfileProps = {
  // TODO: add props here
};

const PageProfile: React.FC<PageProfileProps> = (props) => {
  const { userRole } = useContext(AppContext);

  return (
    <BasePage currPage="profile">
      <div className="h-full overflow-y-auto">
        {userRole === "approved_user" ? <ViewProfile /> : <ViewAdminProfile />}
      </div>
    </BasePage>
  );
};

export default PageProfile;
